import * as React from 'react';
import { RadioButtons } from '@grandvisionhq/forms';
import { useIntl, useDispatch, useSelector } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { CustomerType } from '../../../types.js';
import { toggleIsCompany } from '../../actions.js';
import { getCompany } from '../../selectors.js';

const CompanySelect = ()=>{
    var ref;
    const { getLabel  } = useIntl();
    const checkoutSettings = useCheckoutSettings();
    const dispatch = useDispatch();
    const company = useSelector(getCompany);
    const isCompanyEnabled = (ref = checkoutSettings.features) === null || ref === void 0 ? void 0 : ref.isCompanyEnabled;
    const labels = {
        customerType: {
            private: getLabel('checkout.customerType.private'),
            company: getLabel('checkout.customerType.company')
        }
    };
    const onToggleIsCompany = (radio)=>{
        dispatch(toggleIsCompany({
            enabled: radio.value === CustomerType.Company
        }));
    };
    if (!Boolean(isCompanyEnabled)) return null;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(RadioButtons, {
        scope: "orderType",
        alignment: "horizontal",
        onChange: onToggleIsCompany,
        initialValue: Boolean(company) ? CustomerType.Company : CustomerType.Private,
        items: [
            {
                value: CustomerType.Private,
                label: labels.customerType.private
            },
            {
                value: CustomerType.Company,
                label: labels.customerType.company
            }, 
        ]
    }));
};

export { CompanySelect };
//# sourceMappingURL=CompanySelect.js.map
